import { AuthFailedException } from './auth-failed-exception';

/**
 * Exception type for terminal authentication failures that should not be retried.
 */
export class AuthenticationFailedDoNotRetryException extends AuthFailedException {
  name = 'AuthenticationFailedDoNotRetryException';

  constructor(message: string, readonly cause?: Error) {
    super(message);
    Object.setPrototypeOf(
      this,
      AuthenticationFailedDoNotRetryException.prototype,
    );
  }
}
